function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5625 2.5C5.86719 2.5 6.125 2.75781 6.125 3.0625V4H9.875V3.0625C9.875 2.75781 10.1328 2.5 10.4375 2.5C10.7422 2.5 11 2.75781 11 3.0625V4H11.75C12.5703 4 13.25 4.67969 13.25 5.5V12.25C13.25 13.0703 12.5703 13.75 11.75 13.75H4.25C3.42969 13.75 2.75 13.0703 2.75 12.25V5.5C2.75 4.67969 3.42969 4 4.25 4H5V3.0625C5 2.75781 5.25781 2.5 5.5625 2.5ZM5.5625 5.125H4.25C4.03906 5.125 3.875 5.28906 3.875 5.5V6.625H12.125V5.5C12.125 5.28906 11.9609 5.125 11.75 5.125H5.5625ZM3.875 7.75V12.25C3.875 12.4609 4.03906 12.625 4.25 12.625H11.75C11.9609 12.625 12.125 12.4609 12.125 12.25V7.75H3.875Z",
  fill: "#636766"
});

function SvgCampaignCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignCalendar);
export default __webpack_public_path__ + "static/media/campaign-calendar.44d813f3.svg";
export { ForwardRef as ReactComponent };